import {
	DEPLOY_JOB_POLL_MS,
	normalizeDeployJob,
	normalizeVerification,
	isDeployJobFailed,
	isDeployAwaitingReview,
	isDeployTerminal,
} from "./deployApiShared";
import * as wordpressDeployApi from "./wordpressDeployApi";
import * as shopifyDeployApi from "./shopifyDeployApi";
import { externalDeployWritingAssistant } from "./writingAssistantApi";

export {
	DEPLOY_JOB_POLL_MS,
	normalizeDeployJob,
	normalizeVerification,
	isDeployJobFailed,
	isDeployAwaitingReview,
	isDeployTerminal,
};

export function getWritingDeployApi(platform) {
	if (String(platform || "").toLowerCase() === "shopify") {
		return shopifyDeployApi;
	}
	return wordpressDeployApi;
}

export async function listDeployJobs(websiteId, platform) {
	return getWritingDeployApi(platform).listDeployJobs(websiteId);
}

export async function deployAllFromWriting({
	websiteId,
	writingJobId,
	url,
	recommendationId,
	changeIndices,
	platform,
}) {
	if (String(platform || "").toLowerCase() === "shopify") {
		return shopifyDeployApi.deployFromWriting({
			websiteId,
			writingJobId,
			url,
			recommendationId,
			changeIndices,
		});
	}
	return externalDeployWritingAssistant({
		websiteId,
		jobId: writingJobId,
		recommendationId,
		scope: "recommendation",
	});
}
